export default {"src":"/_next/static/media/download1.0e01c1d8.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};